// Version 1.4.0-1 2025-09-11

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryParam } from '../hooks/useQueryParam';
import { useHW } from '../hooks/useHW';

// Több HW konfiguráció
const hwConfig = {
  HW1: {
    apikey: 'API-002',
    variables: ['HE_lamp_kert', 'HE_terasz', 'HE_szivattyu', 'HE_lamp_udvar', 'Restart_number', 'HE_kapu_1', 'He_ajto'],
  },
  HW2: {
    apikey: 'API-005',
    variables: ['Relay'],
  },
};

// Alap kapcsolók (UI)
const baseSwitches = [
  { label: 'Kert', value: false, onColor: '#FF4500', offColor: '#39FF14' },
  { label: 'Terasz', value: false, onColor: '#FF4500', offColor: '#39FF14' },
  { label: 'Szivattyú', value: false, onColor: '#FF4500', offColor: '#39FF14' },
  { label: 'Udvar', value: false, onColor: '#FF4500', offColor: '#39FF14' },
];

const HegyaljaPage = () => {
  const navigate = useNavigate();
  const [hwKeyParam] = useQueryParam('hw', 'HW1');
  const hwKey = Object.prototype.hasOwnProperty.call(hwConfig, hwKeyParam) ? hwKeyParam : 'HW1';
  const currentHW = hwConfig[hwKey];

  const { state, actions } = useHW(
    currentHW,
    hwKey,
    baseSwitches,
    { apikey: hwConfig.HW2.apikey, var: 'Relay' } // S-005
  );

  const {
    switches, heartbeat, lastRequestTime, serverValue, responseText,
    temperatureBMP, temperatureAHT, pressBMP, humiAHT,
    restartNumber, heKapu1, heAjto, s005
  } = state;

  const {
    toggleSwitch, changeValue, postRestart, toggleKapu, toggleAjto, toggleS005
  } = actions;

  return (
    <div className="pageContainer">
      <div className="headerRow">
        <button className="backButton" onClick={() => navigate('/')}>
          Vissza
        </button>
        <h2 className="text">Hegyalja utca X3.10</h2>
        <div className={`lamp ${heartbeat ? 'active' : ''}`}></div>
      </div>

      <div className="toggleContainer">
        <div className="toggleRow">
          {switches.slice(0, 3).map((sw, i) => (
            <label className="toggleContainer" key={i}>
              {sw.label}
              <input
                type="checkbox"
                checked={sw.value}
                onChange={() => toggleSwitch(i)}
                className="customSwitch"
              />
            </label>
          ))}
        </div>

        {/* Udvar + S-005 egy sorban */}
        <div className="toggleRow">
          <label className="toggleContainer">
            {switches[3].label}
            <input
              type="checkbox"
              checked={!!switches[3]?.value}
              onChange={() => toggleSwitch(3)}
              className="customSwitch"
            />
          </label>

          {/* S-005 a HW2-re, Relay változóval */}
          <label className="toggleContainer">
            S-005
            <input
              type="checkbox"
              checked={s005}
              onChange={toggleS005}
              className="customSwitch"
            />
          </label>
        </div>
      </div>

      <div className="securityCodeRow">
        <h2>Biztonsági kód</h2>
        <div style={{ margin: '0 10px' }}>
          <button onClick={() => changeValue(-1)} className="counterButtonSmall">-</button>
        </div>
        <p className="counterTextSmall">{serverValue}</p>
        <div style={{ margin: '0 10px' }}>
          <button onClick={() => changeValue(1)} className="counterButtonSmall">+</button>
        </div>
      </div>

      <div className="switchRow">
        <div className="switchContainer" onClick={postRestart}>
          <h3>Restart</h3>
          <p>{restartNumber}</p>
        </div>
        <div className="switchContainer" onClick={toggleKapu}>
          <h3>Kapu</h3>
          <p>{heKapu1 ? 'Nyitva' : 'Zárva'}</p>
        </div>
        <div className="switchContainer" onClick={toggleAjto}>
          <h3>Ajtó</h3>
          <p>{heAjto ? 'Nyitva' : 'Zárva'}</p>
        </div>
      </div>

      <div className="temperatureRow">
        <div className="temperatureBox">
          <h3>Temp_BMP</h3>
          <p>{temperatureBMP !== null ? `${temperatureBMP} °C` : 'N/A'}</p>
        </div>
        <div className="temperatureBox">
          <h3>Temp_AHT</h3>
          <p>{temperatureAHT !== null ? `${temperatureAHT} °C` : 'N/A'}</p>
        </div>
      </div>
      <div className="temperatureRow">
        <div className="temperatureBox">
          <h3>Press_BMP</h3>
          <p>{pressBMP !== null ? `${pressBMP} hPa` : 'N/A'}</p>
        </div>
        <div className="temperatureBox">
          <h3>Humi_AHT</h3>
          <p>{humiAHT !== null ? `${humiAHT} %` : 'N/A'}</p>
        </div>
      </div>

      <div className="responseContainer">
        <p className="responseText">{responseText}</p>
        <p className="responseText">Lekér: {lastRequestTime}</p>
      </div>
    </div>
  );
};

export default HegyaljaPage;
